/* eslint-disable @typescript-eslint/no-explicit-any */
import { EComponentType, useAppSettings } from '../../providers/appSettings';
import * as React from 'react';
export function Ionic(props) {
    const { children } = props;
    return children;
}
export function Web(props) {
    const { children } = props;
    return children;
}
export function UXComponent(props) {
    const { children } = props;
    const { settings } = useAppSettings();
    const getIonicElement = () => {
        const childArray = React.Children.toArray(children);
        const element = childArray.find((x) => x.type.name === Ionic.name);
        return element || children;
    };
    const getWebElement = () => {
        const childArray = React.Children.toArray(children);
        const element = childArray.find((x) => x.type.name === Web.name);
        return element || children;
    };
    if (settings['componentType'] === EComponentType.Ionic) {
        return getIonicElement();
    }
    else {
        return getWebElement();
    }
}
UXComponent.Ionic = Ionic;
UXComponent.Web = Web;
//# sourceMappingURL=index.js.map